var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixEcomV1BackInStockNotificationRequest from '@wix/ambassador-ecom-v1-back-in-stock-notification-request/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
let __verbose = false;
function __log(...args) {
    __verbose && console.log(...args);
}
function __inspect(obj) {
    return obj;
}
export const __debug = {
    verboseLogging: {
        on: () => (__verbose = true),
        off: () => (__verbose = false),
    },
};
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    Status["UNSPECIFIED"] = "UNSPECIFIED";
    /** initial status of all new requests */
    Status["RECEIVED"] = "RECEIVED";
    Status["PROCESSING"] = "PROCESSING";
    Status["NOTIFICATION_SENT"] = "NOTIFICATION_SENT";
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
const _backInStockItemDetails = { image: 'wix.common.Image' };
const _createBackInStockNotificationRequestRequest = {
    itemDetails: '_backInStockItemDetails',
};
const _createBackInStockNotificationRequestResponse = {};
const _deleteBackInStockNotificationRequestRequest = {};
const _deleteBackInStockNotificationRequestResponse = {};
const _getBackInStockNotificationRequestRequest = {};
const _getBackInStockNotificationRequestResponse = {};
const _getBackInStockNotificationRequestsCountByCatalogReferencesRequest = {};
const _getBackInStockNotificationRequestsCountByCatalogReferencesResponse = {};
const _markAsNotificationSentRequest = {};
const _markAsNotificationSentResponse = {};
const _queryBackInStockNotificationRequestsRequest = {};
const _queryBackInStockNotificationRequestsResponse = {};
const _reportItemsBackInStockRequest = {
    itemDetails: '_backInStockItemDetails',
};
const _reportItemsBackInStockResponse = {};
/**
 * Create a BackInStockNotificationRequest. May not create new entry if there is existing non resolved request
 * for same CatalogReference and email (will return existing request in response)
 * @param request - Notification request data (id is ignored, as it's generated by server)
 * @public
 * @documentationMaturity preview
 * @requiredField options
 * @requiredField options.itemDetails
 * @requiredField options.itemDetails.name
 * @requiredField options.itemDetails.price
 * @requiredField request
 * @requiredField request.catalogReference
 * @requiredField request.catalogReference.appId
 * @requiredField request.catalogReference.catalogItemId
 * @requiredField request.email
 * @returns Created BackInStockNotificationRequest
 */
export function createBackInStockNotificationRequest(request, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            request: '$[0]',
            itemDetails: '$[1].itemDetails',
        };
        const responseTransformation = '$.request';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createBackInStockNotificationRequestRequest,
            depSchemas: { _backInStockItemDetails },
            fqdnTransformation: {
                paths: [...['request']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createBackInStockNotificationRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['request']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([request, options]);
        const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.createBackInStockNotificationRequest(payload);
        __log(`"CreateBackInStockNotificationRequest" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'request',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get BackInStockNotificationRequest by id
 * @param _id - BackInStockNotificationRequest id
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @returns Requested BackInStockNotificationRequest
 */
export function getBackInStockNotificationRequest(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$.request';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getBackInStockNotificationRequestRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getBackInStockNotificationRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['request']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.getBackInStockNotificationRequest(payload);
        __log(`"GetBackInStockNotificationRequest" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Delete BackInStockNotificationRequest by id
 * @param _id - BackInStockNotificationRequest id
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 */
export function deleteBackInStockNotificationRequest(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteBackInStockNotificationRequestRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteBackInStockNotificationRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.deleteBackInStockNotificationRequest(payload);
        __log(`"DeleteBackInStockNotificationRequest" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update BackInStockNotificationRequest status to `NOTIFICATION_SENT`
 * @param _id - BackInStockNotificationRequest id
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 */
export function markAsNotificationSent(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _markAsNotificationSentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _markAsNotificationSentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['request']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.markAsNotificationSent(payload);
        __log(`"MarkAsNotificationSent" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns BackInStockNotificationRequests matching given search parameters
 * @internal
 * @documentationMaturity preview
 */
export function queryBackInStockNotificationRequests() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.requests',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryBackInStockNotificationRequestsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryBackInStockNotificationRequestsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#requests']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.queryBackInStockNotificationRequests(payload);
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOpts);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Returns the number of BackInStockNotificationRequests for a given CatalogReferences.
 * @param catalogReferences - Back in stock requests to be counted identified by their CatalogReference.
 * @public
 * @documentationMaturity preview
 * @requiredField catalogReferences
 */
export function getBackInStockNotificationRequestsCountByCatalogReferences(catalogReferences) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { catalogReferences: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getBackInStockNotificationRequestsCountByCatalogReferencesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getBackInStockNotificationRequestsCountByCatalogReferencesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([catalogReferences]);
        const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.getBackInStockNotificationRequestsCountByCatalogReferences(payload);
        __log(`"GetBackInStockNotificationRequestsCountByCatalogReferences" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'catalogReferences',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Will handle all BackInStockNotificationRequests referencing given item (if `catalog_reference` parameter is present)
 * Otherwise (if `request_ids` parameter present) will handle BackInStockNotificationRequests with given ids
 * @public
 * @documentationMaturity preview
 * @requiredField options
 * @requiredField options.itemDetails
 * @requiredField options.itemDetails.name
 * @requiredField options.itemDetails.price
 */
export function reportItemsBackInStock(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            catalogReference: '$[0].catalogReference',
            requestIds: '$[0].requestIds',
            itemDetails: '$[0].itemDetails',
            extraAutomationTemplateParameters: '$[0].extraAutomationTemplateParameters',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reportItemsBackInStockRequest,
            depSchemas: { _backInStockItemDetails },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reportItemsBackInStockResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEcomV1BackInStockNotificationRequest.reportItemsBackInStock(payload);
        __log(`"ReportItemsBackInStock" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=ecom-v1-back-in-stock-notification-request.universal.js.map